import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import type {
  AmericanFootballFixture,
  AmericanFootballPeriod
} from '@ps/web-shared-generated-graphql/sports';
import React from 'react';

import EventStatusMessage from '../../EventStatusMessage/EventStatusMessage';
import FormatEventStatusDuration from '../FormatEventStatusDuration/FormatEventStatusDuration';
import GameTime from '../GameTime/GameTime';

import {
  TXTWCL_End_of_Overtime,
  TXTWCL_End_of_Q1,
  TXTWCL_End_of_Q2,
  TXTWCL_End_of_Q3,
  TXTWCL_End_of_Q4,
  TXTWCL_Game_Ended,
  TXTWCL_Overtime,
  TXTWCL_Q1,
  TXTWCL_Q2,
  TXTWCL_Q3,
  TXTWCL_Q4
} from './AmericanFootballScoreboardInPlayStatus.messages.json';

const translationMap: Record<AmericanFootballPeriod, TranslationTag> = {
  PERIOD_1: TXTWCL_Q1,
  PERIOD_2: TXTWCL_Q2,
  PERIOD_3: TXTWCL_Q3,
  PERIOD_4: TXTWCL_Q4,
  END_PERIOD_1: TXTWCL_End_of_Q1,
  END_PERIOD_2: TXTWCL_End_of_Q2,
  END_PERIOD_3: TXTWCL_End_of_Q3,
  END_PERIOD_4: TXTWCL_End_of_Q4,
  OVERTIME: TXTWCL_Overtime,
  END_OVERTIME: TXTWCL_End_of_Overtime,
  END: TXTWCL_Game_Ended
};

interface Props {
  americanFootballFixture: AmericanFootballFixture;
}

const FootballScoreboardInPlayStatus: React.FC<Props> = ({ americanFootballFixture }) => {
  const { score, clock } = americanFootballFixture;

  if (!score || !clock) {
    return <EventStatusMessage messageId="IN_PLAY" icon={InPlay} size="XSmall" />;
  }

  switch (clock.period) {
    case 'END':
    case 'END_PERIOD_1':
    case 'END_PERIOD_2':
    case 'END_PERIOD_3':
    case 'END_PERIOD_4':
    case 'END_OVERTIME':
      return (
        <GameTime>
          <span>
            <Translation {...translationMap[clock.period]} />
          </span>
        </GameTime>
      );
    case 'PERIOD_1':
    case 'PERIOD_2':
    case 'PERIOD_3':
    case 'PERIOD_4':
    case 'OVERTIME':
      return (
        <GameTime>
          <span>
            <Translation {...translationMap[clock.period]} />
            <FormatEventStatusDuration intervalInSeconds={clock.timeRemaining} isCountdownTimer />
          </span>
        </GameTime>
      );
    default:
      return <EventStatusMessage messageId="IN_PLAY" icon={InPlay} size="XSmall" />;
  }
};

export default FootballScoreboardInPlayStatus;
